import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { openRecordingVideo, retrievePresignedUrl } from '~/actions/recents'
import Image from '~/components/common/image'
import { LabelBold01 } from '~/components/common/typography'
import { translate } from '~/core/translate'
import { getKeyMomentParentRecording } from '~/selectors/session-details'
import RecordingVideoPlayer from './video-player'
import MediaBox from '../box/media-box'

const Badges = styled.div`
  bottom: 8px;
  left: 8px;
  position: absolute;
`

const TitleBadge = styled(LabelBold01)`
  background-color: #292929;
  border-radius: 4px;
  color: white;
  margin-right: 4px;
  padding: 4px 8px;
`

const Counter = styled(TitleBadge)`
  background-color: ${({ theme }) => theme._neo.action01};
`

const RecordingPreview = ({ counter, className, recording, sessionId }) => {
  const [presignedThumbnailUrl, setPresignedThumbnailUrl] = useState(null)
  const dispatch = useDispatch()
  const { duration, isHighlight, thumbnailUrl, url } = recording
  const title = recording.keyMoments?.length ? translate('recording_full') : translate('recording')
  const parentRecording = useSelector(getKeyMomentParentRecording(sessionId, url))
  const showPreviewFromThumbnailUrl = Boolean(thumbnailUrl)

  const openVideo = () => {
    dispatch(openRecordingVideo({
      recording: parentRecording ?? recording,
      sessionId,
      url
    }))
  }

  const getThumbnailUrl = async () => {
    const image = await dispatch(retrievePresignedUrl(thumbnailUrl))

    setPresignedThumbnailUrl(image)
  }

  useEffect(() => {
    if (showPreviewFromThumbnailUrl) {
      getThumbnailUrl()
    }
  }, [])

  return (
    <MediaBox
      callback={openVideo}
      className={className}
      aria-label={translate('open_recording')}
    >
      {showPreviewFromThumbnailUrl
        ? <Image alt='' src={presignedThumbnailUrl} />
        : (
          <RecordingVideoPlayer
            canPlay={false}
            recording={recording}
          />
          )}

      <Badges>
        <TitleBadge>
          {!isHighlight && `${title} • `}
          {duration}
        </TitleBadge>
        {Boolean(counter) && <Counter>+{counter}</Counter>}
      </Badges>
    </MediaBox>
  )
}

export default RecordingPreview
